export class ActionButtonModel {
  title: string;
  canAdd: boolean;
  click?: boolean;
}
